import withErrorBoundary from '../../../hoc/withErrorBoundary';
import { EmbeddedPacket } from './EmbeddedPacket';

export default withErrorBoundary(EmbeddedPacket, 'EmbeddedPacket');
